import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

// import DigitTimerComponent from 'components/Shared/ScarcityVacancy/DigitalTimer';

export default function ScarcityVacancyComponent() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        alignItems: 'center',
        background: 'linear-gradient(270deg, #258DBF 20%, #054F77 100%)',
        display: 'flex',
        flexDirection: 'row',
        gap: { xs: 0, md: 5 },
        justifyContent: 'center', // { xs: 'space-between', sm: 'space-evenly' },
        textAlign: { xs: 'center', md: 'unset' },
        position: 'relative',
        py: { xs: 1, md: 2 },
        px: { xs: 1.5, md: 2 },
      }}
    >
      <Box display="flex" alignItems="center" gap={{ xs: 1, sm: 2 }}>
        <Typography
          display="block"
          variant={isMobile ? 'caption' : 'h6'}
          fontSize={{ xs: '12px', sm: '16px', md: '20px' }}
          textAlign="center"
          color="white"
        >
          <strong>Reserve</strong> seu intercâmbio <strong>este mês</strong> e
          ganhe um <strong>pacote com 6 bônus exclusivos</strong> para{' '}
          <strong>evoluir na carreira</strong>
        </Typography>
      </Box>

      {/* <Box
        display="flex"
        alignItems="center"
        flexDirection={{ xs: 'column', md: 'row' }}
        gap={{ xs: 1, sm: 2 }}
      >
        <Typography
          color="#FFFFFF"
          component="p"
          fontSize={{ xs: '12px', md: '20px' }}
          fontWeight={700}
        >
          Vagas restantes:
        </Typography>

        <Box
          alignItems="center"
          color="#FFFFFF"
          display="flex"
          justifyContent="center"
        >
          <DigitTimerComponent />
        </Box>
      </Box> */}
    </Box>
  );
}
